import { Reveal } from "../components/Reveal";
import { SITE, whatsappLink } from "../lib/data";
import { WhatsappLogo, Phone, MapPin, Clock } from "@phosphor-icons/react";

export default function Contatti() {
  return (
    <div data-testid="contatti-page" className="min-h-screen">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-44 pb-28">
        <div className="grid md:grid-cols-12 gap-14 items-start">
          <Reveal className="md:col-span-6">
            <div className="overline text-secondary mb-6">Contatti</div>
            <h1 className="serif text-5xl md:text-7xl lg:text-8xl font-light tracking-tighter text-primary leading-[0.9]">
              Parliamone.
            </h1>
            <p className="mt-8 text-lg font-light text-muted-foreground max-w-md leading-relaxed">
              Il modo più veloce per ricevere un preventivo è scriverci su WhatsApp o chiamarci. Ti rispondiamo in giornata con una proposta su misura per il tuo immobile a {SITE.city}.
            </p>
            <div className="mt-10 flex items-center gap-3 text-muted-foreground font-light">
              <Clock size={22} weight="thin" /> Lun–Dom · 08:00 – 20:00
            </div>
            <div className="mt-3 flex items-center gap-3 text-muted-foreground font-light">
              <MapPin size={22} weight="thin" /> Roma e provincia
            </div>
          </Reveal>

          <Reveal delay={0.15} className="md:col-span-6 w-full">
            <div className="space-y-4">
              <a href={whatsappLink()} target="_blank" rel="noreferrer" data-testid="contatti-whatsapp"
                 className="group flex items-center justify-between rounded-2xl bg-primary text-primary-foreground p-8 hover:bg-primary/90 transition-colors">
                <div>
                  <div className="overline text-secondary mb-2">Consigliato</div>
                  <div className="serif text-3xl font-light">WhatsApp</div>
                </div>
                <WhatsappLogo size={44} weight="fill" className="group-hover:scale-110 transition-transform" />
              </a>
              <a href={`tel:${SITE.phoneHref}`} data-testid="contatti-phone"
                 className="group flex items-center justify-between rounded-2xl border border-border p-8 hover:border-primary transition-colors">
                <div>
                  <div className="overline text-muted-foreground mb-2">Chiama</div>
                  <div className="serif text-3xl font-light text-primary">{SITE.phone}</div>
                </div>
                <Phone size={40} weight="thin" className="text-primary group-hover:scale-110 transition-transform" />
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
